module.exports = __webpack_public_path__ + "media/1_2.8d076af9.wav";